import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import { readFavourites } from "../lib/favourites_store"

// On the owner's saved walk: asks which of this device's favourites would fit into the walk, and
// shows them with a button to add each one. Asks again when hearts change.
export default class extends Controller {
  static values = { url: String, slug: String }

  connect() {
    this.loadedIds = null
    this.load()
  }

  disconnect() {
    clearTimeout(this.timer)
    this.abort?.abort()
  }

  refresh() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.load(), 300)
  }

  async load() {
    const key = readFavourites(this.slugValue).sort((a, b) => a - b).join(",")
    if (key === this.loadedIds) return
    this.loadedIds = key
    if (!key) {
      this.element.replaceChildren()
      return
    }

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("ids", key)

    this.abort?.abort()
    this.abort = new AbortController()
    try {
      const response = await fetch(url, { headers: { Accept: "text/vnd.turbo-stream.html" }, signal: this.abort.signal })
      if (response.ok) Turbo.renderStreamMessage(await response.text())
    } catch (error) {
      if (error.name !== "AbortError") console.warn("Couldn't check your favourites:", error)
    }
  }
}
